import { render } from "./MainSideBar.vue?vue&type=template&id=3f60f473&lang=true"
import script from "./MainSideBar.vue?vue&type=script&lang=js"
export * from "./MainSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__